// extracted by mini-css-extract-plugin
module.exports = {"select":"ay-QFLR5","withValue":"obfy_I_2","inline":"_1wib24EH"};